import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { ComponentTheme } from '@helpers/themeEnum';
import { headingStyles, link, paragraphSmall, subtitle } from '@helpers/typography';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  --arrowColour: ${brand.grey.grey60};
  --bgColour: ${brand.grey.grey16};
  --fgColour: ${brand.white};

  &[data-theme=${ComponentTheme.Orange}] {
    --arrowColour: ${brand.orange.base};
    --bgColour: ${brand.orange.tint};
    --fgColour: ${brand.grey.grey16};
  }

  &[data-theme=${ComponentTheme.Green}] {
    --arrowColour: ${brand.green.base};
    --bgColour: ${brand.green.tint};
    --fgColour: ${brand.grey.grey16};
  }

  &[data-theme=${ComponentTheme.Blue}] {
    --arrowColour: ${brand.blue.base};
    --bgColour: ${brand.blue.tint};
    --fgColour: ${brand.grey.grey16};
  }

  &[data-theme=${ComponentTheme.Yellow}] {
    --arrowColour: ${brand.yellow.base};
    --bgColour: ${brand.yellow.tint};
    --fgColour: ${brand.grey.grey16};
  }

  &[data-theme=${ComponentTheme.White}] {
    --arrowColour: ${brand.grey.grey44};
    --bgColour: ${brand.grey.grey97};
    --fgColour: ${brand.grey.grey16};
  }
`;
const Inner = styled.div `
  color: var(--fgColour);
  background-color: var(--bgColour);
  padding: ${fluid(24, 32)} 32px;
  border-radius: 24px;
`;
const Title = styled.h2 `
  ${headingStyles};

  font-size: ${fluid(18, 24)};
  line-height: ${fluid(28, 34)};
  margin-bottom: 16px;
`;
const ListLabel = styled.p `
  ${subtitle};

  font-weight: 600;
  margin-bottom: 12px;
`;
const LinkList = styled.ul `
  display: flex;
  flex-direction: column;
  gap: 12px;

  li {
    ${paragraphSmall};

    margin: 0;
  }

  a {
    ${link};

    display: flex;
    gap: 16px;
    align-items: flex-start;
    color: currentColor;
    text-decoration-color: transparent;
    text-underline-offset: 3px;

    svg {
      ${transition('transform')};

      color: var(--arrowColour);
      width: 16px;
      height: ${fluid(26, 28)};
      flex: 0 0 16px;
    }

    &:focus,
    &:hover {
      text-decoration-color: var(--arrowColour);

      svg {
        transform: translateX(4px);
      }
    }
  }
`;
const PageContentsListStyles = {
    Container,
    Title,
    ListLabel,
    LinkList,
    Inner,
};
export default PageContentsListStyles;
